export const forEachItemStartingWith = (prefix, callback) => {
  for (let index = 0; index < window.localStorage.length; index++) {
    const key = window.localStorage.key(index);
    if (key.startsWith(prefix)) {
      const shouldBreak = callback(key);
      if (shouldBreak) {
        break;
      }
    }
  }
};

export const findKeyStartingWith = (prefix) => {
  let foundKey = null;
  forEachItemStartingWith(prefix, (key) => {
    foundKey = key;
    return true;
  });
  return foundKey;
};

export const sortListByField = (allItems, field) => {
  const sortFunctions = {
    order: (item1, item2) => item1.order - item2.order,
  };
  const sortFunction = sortFunctions[field] || sortFunctions.order;

  return allItems.sort(sortFunction);
};
